<!--横向滑动推荐新闻类  view:15-->
<template>
    <div class="view15Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.imgUrl" :name="item.name" :news-kind="item.newsKind"
                      :is-chat="item.isChat" :card-key="ix"
                      @on-click="()=>onRouter(item.linkUrl,item.newsId,item.newsKind,item.name,item.content,item.source,item.datePublish,item.videoUrl,item.imgUrl)"
                      :key="`tips-quick-${ix}`" card-type="news"/>
        </CrossSlip>
    </div>
</template>


<script>
    import CrossSlip from "../Use/cross-slip-wrapper";
    import BaseCard from "../Use/base-card";
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        name: "View15",
        components: {
            BaseCard, CrossSlip
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {};

        },
        methods: {
            ...mapMutations([
                "setNewsContent"
            ]),
            onRouter(path, id, newsKind, name, content, source, datePublish, videoUrl, imgUrl) {
                this.setNewsContent({newsTitle: name, content, source, datePublish, newsKind, path, videoUrl, imgUrl});
                this.$emit("on-show",id,{newsTitle: name, content, source, datePublish, newsKind, path, videoUrl, imgUrl}, 7);
            }

        }
    };
</script>
<style lang="less" scoped>
    .view15Wrapper {


    }

</style>
